/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon16Regular = forwardRef('ArrowDRadiusUpLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.22 1.97a.75.75 0 0 1 1.06 1.06L3.06 6.25H8A6.75 6.75 0 0 1 14.75 13v.25a.75.75 0 0 1-1.5 0V13c0-2.9-2.35-5.25-5.25-5.25H3.06l3.22 3.22a.75.75 0 1 1-1.06 1.06L1.568 8.38a1.95 1.95 0 0 1 0-2.758L5.22 1.97Z" })));
});
